export const DEFAULT_VIEW = { rotation: 0, zoom: 1, fit: "page", page: 1, x: 0, y: 0 };
export const clampZoom = (zoom) => Math.min(8, Math.max(0.05, Number(zoom) || 1));
const bounded = (value, fallback, min, max) => {
  const number = Number(value);
  return Number.isFinite(number) ? Math.min(max, Math.max(min, number)) : fallback;
};

export function normalizeView(view = {}) {
  return {
    rotation: ((Math.round((Number(view.rotation) || 0) / 90) * 90) % 360 + 360) % 360,
    zoom: clampZoom(view.zoom),
    fit: ["page", "width"].includes(view.fit) ? view.fit : "manual",
    page: Math.round(bounded(view.page, 1, 1, 100000)),
    x: bounded(view.x, 0, -100000, 100000),
    y: bounded(view.y, 0, -100000, 100000),
  };
}

export function viewFromSearch(search) {
  const query = new URLSearchParams(search);
  const view = {};
  Object.keys(DEFAULT_VIEW).forEach((key) => { if (query.has(key)) view[key] = query.get(key); });
  return normalizeView({ ...DEFAULT_VIEW, ...view });
}

export function originalContentPath(document) {
  if (document.documentType === "invoice-delivery-note") return `/api/purchasing/supplier-invoices/${encodeURIComponent(document.invoiceId)}/delivery-notes/${encodeURIComponent(document.id)}/original-content`;
  return `/api/purchasing/${document.documentType === "supplier-invoice" ? "supplier-invoices" : "ocr-imports"}/${encodeURIComponent(document.id)}/original-content`;
}

export function viewerPath(document, view) {
  const query = new URLSearchParams({
    business_unit_id: String(document.businessUnitId),
    name: document.name || "",
    ...(["supplier-invoice", "invoice-delivery-note"].includes(document.documentType) ? { document_type: document.documentType, ...(document.documentType === "invoice-delivery-note" ? { invoice_id: String(document.invoiceId) } : {}) } : {}),
    ...normalizeView(view),
  });
  return `/purchasing/originals/${encodeURIComponent(document.id)}?${query}`;
}

export function displayZoom(view, size, viewport) {
  if (view.fit === "manual") return view.zoom;
  const rotated = view.rotation % 180 !== 0;
  const width = rotated ? size.height : size.width;
  const height = rotated ? size.width : size.height;
  const fitWidth = Math.max(1, viewport.width - 32) / Math.max(1, width);
  return clampZoom(view.fit === "width" ? fitWidth : Math.min(fitWidth, Math.max(1, viewport.height - 32) / Math.max(1, height)));
}

export function viewerScrollGeometry(size, viewport, zoom, rotation) {
  const rotated = rotation % 180 !== 0;
  const width = Math.max(viewport.width, (rotated ? size.height : size.width) * zoom + 32);
  const height = Math.max(viewport.height, (rotated ? size.width : size.height) * zoom + 32);
  return { width, height, maxX: width - viewport.width, maxY: height - viewport.height };
}
